import { forwardRef } from 'react';
import { useTranslation, SkeletonFrame, useBreakpoint, Breakpoints } from '@nextgen-web-framework/all';
import { CmsComponent } from '@commerce-webcomponents/ui-composite';
import { CMSTransformerDataType } from '../../types/common';
import styles from './ContentListingContainer.module.scss';
import type { ContentListingProps } from './types/propsTypes';

const ContentListingContainer = forwardRef<HTMLSpanElement, ContentListingProps>((props, ref) => {
  const t = useTranslation();
  const totalCount = props.count;
  const viewPortType = useBreakpoint() as Breakpoints;
  const isMobileView = [Breakpoints.XS, Breakpoints.SM].includes(viewPortType);
  const componentRestProps = {
    customClass: styles['content-card-listing-container'],
  };
  const noOfSkeletons = props?.contentData.length % 10 === 0 ? 10 : props?.contentData.length % 10;
  return (
    <div className={styles['content-listing-container']} data-testid="content-listing-container-test-id">
      <div className={styles['content-listing-count']}>
        {t('web.contentlisting.results').replace(/{totalCount}/g, String(totalCount))}
      </div>
      <div
        className={`${styles['content-listing-result']} ${
          props.leftNav ? styles['content-listing-with-left-nav'] : styles['content-listing-without-left-nav']
        }`}
      >
        {props?.contentData.map((content: CMSTransformerDataType) => (
          <div key={content.title} className={styles['content-listing-card']}>
            <CmsComponent componentKey={props.componentKey} data={content} {...componentRestProps} />
          </div>
        ))}
        {props.loading &&
          props.hasMore &&
          Array.from({ length: noOfSkeletons }).map(() => (
            // eslint-disable-next-line
            <div className={styles['content-listing-card']}>
              <SkeletonFrame heightValue={isMobileView ? '360' : '440'} borderRadiusValue="12" isRoundCorner />
            </div>
          ))}
        {props?.contentData.length > 0 && <span ref={ref}></span>}
      </div>
    </div>
  );
});
ContentListingContainer.displayName = 'ContentListingContainer';
export default ContentListingContainer;
export { ContentListingProps };
